import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { BeneficiariesList, BenefitBeneficiaryCard } from "src/app/models/beneficiary";
import { AbstractControl, FormArray, FormGroup, FormBuilder } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";


@Component({
    selector: "mwp-beneficiaries-benefit-select",
    templateUrl: "./beneficiaries-benefit-select.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})


export class BeneficiariesBenefitSelectComponent implements OnInit {
    @Input() beneficiariesList: BeneficiariesList;
    @Input() benefitBeneficiaryCard: BenefitBeneficiaryCard;
    @Input() public saveButtonText: string;
    @Output() public emitSavePayload: EventEmitter<number[]> = new EventEmitter();
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();


    public beneficiariesForm: FormGroup;
    public beneficiaryListArrayName: string = 'beneficiaryList';

    constructor(
        private formBuilder: FormBuilder,
    ) {
    }

    ngOnInit(): void {
        let l_FormArray_Benefit: FormArray = new FormArray([]);
        let l_Data: BeneficiariesList = this.beneficiariesList;

        l_Data.beneficiaryCards.forEach((bfd) => {
            l_FormArray_Benefit.push(
                this.formBuilder.group({
                    isSelected: [{ value: bfd.memberBenefitID == this.benefitBeneficiaryCard.memberBenefitID ? true : false, disabled: bfd.memberBenefitID == this.benefitBeneficiaryCard.memberBenefitID }],
                    benefit: [bfd.enrollmentName],
                    memberBenefitID: [bfd.memberBenefitID]
                })
            );
        });
        this.beneficiariesForm = this.formBuilder.group({
            [this.beneficiaryListArrayName]: l_FormArray_Benefit
        });

    }

    get gridArray(): FormArray {
        return (<FormArray>(this.beneficiariesForm.get(this.beneficiaryListArrayName)));
    }
    get gridArrayControls(): AbstractControl[] {
        return this.gridArray.controls;
    }

    public selectedGrid(event: MatCheckboxChange, gridId: number): void {
        const l_GridControl: AbstractControl = this.gridArray.at(gridId);
    }

    public cancelForm(): void {
        this.emitCancel.emit();
    }

    public completeForm(): void {
        const l_payload: number[] = [];
        const formArray = this.beneficiariesForm.get('beneficiaryList') as FormArray;

        formArray.controls.forEach((control: AbstractControl) => {
            if (control.get('isSelected')?.value) {
                l_payload.push(control.get('memberBenefitID').value);
            }
        });
        this.emitSavePayload.emit(l_payload);
    }
}